import { render } from "./OnoiQR.vue?vue&type=template&id=19b0a3ea"
import script from "./OnoiQR.vue?vue&type=script&lang=js"
export * from "./OnoiQR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__